module.exports = __webpack_public_path__ + "img/finance-application-display.8e47623c.png";